import classNames from 'classnames';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface TableProps {
  children: ReactNode;
  className?: string;
}

export interface TableWithHiddenColumnProps {
  columnName: string;
}

export const Table: FC<TableProps> = ({ children, className }) => {
  return (
    <table className={classNames('table table-sm table-bordered table-form mt-0 mb-0 ms-xxl-auto w-100', className)}>
      {children}
    </table>
  );
};

export const TableWithHiddenColumn = styled(Table)<TableWithHiddenColumnProps>`
  @media screen and (max-width: 1600px) {
    [data-column='${({ columnName }) => columnName}'] {
      display: none !important;
    }
  }
`;
